import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const PlugIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M20.3321 16.0143L21.5 14.8463L19.1642 12.5106L20.3321 11.3427L18.4969 9.50747C17.4733 8.11025 14.4785 7.97256 13.1524 8.98458L10.7921 6.46908C8.00689 4.11709 3.04992 7.11196 6.16449 11.3703L7.3924 12.5982C8.76423 14.4786 6.62995 16.303 5.06849 14.9221L3.66779 13.6883L2.5 14.8799L3.89185 16.105C7.21515 19.0913 11.5525 14.6851 8.57215 11.4185L7.34424 10.1906C5.8382 7.90372 8.17902 6.5612 9.69611 7.72813L11.9597 10.1512C10.8465 11.803 11.0235 14.0265 12.4906 15.3469L14.3259 17.1822L15.4937 16.0143L17.8295 18.35L18.9974 17.1822L16.6616 14.8464L17.8295 13.6785L20.3321 16.0143H20.3321ZM14.3258 14.8463L13.6585 14.179C12.6574 13.1779 12.6574 11.6764 13.6585 10.6753C14.6595 9.67428 16.1611 9.67428 17.1622 10.6753L17.8295 11.3427L14.3258 14.8463Z"
      />
    </SvgIcon>
  );
});
